<template>
  <div style="display: flex">
    <div class="page_left bg">


      <el-col :span="showdev">
        <div class="content_item" style="margin-right: 10px;">
          <p class="common-title-font" style="margin-top: 0">{{$t('Index.Dev')}}</p>
          <ul>
            <li class="Blue">
              <span
                @click="$router.push({path:'/dev/DevView',query:{devstatus:'normal'}})"> {{devInfo.normalcount}}</span>
              <p>{{$t('Index.normal')}}</p>
            </li>
            <li class="Danger">
              <span @click="$router.push({path:'/dev/DevView',query:{devstatus:'over'}})"> {{devInfo.overcount}}</span>
              <p>{{$t('Index.over')}}</p>

            </li>
            <li class="Info">
              <span
                @click="$router.push({path:'/dev/DevView',query:{devstatus:'offline'}})">{{devInfo.offlinecount}}</span>
              <p>{{$t('Index.offline')}}</p>

            </li>
            <li class="Warning">
              <span>{{devInfo.stopcount}}</span>
              <p>{{$t('AllPage.Stop')}}</p>

            </li>
            <li>
              <span @click="$router.push({path:'/dev/DevView',query:{devstatus:'all'}})">{{devInfo.totalcount}}</span>
              <br>
              {{$t('Index.allnum')}}
            </li>
          </ul>
        </div>
      </el-col>
      <el-col :span="showmon">
        <div class="content_item">
          <p class="common-title-font" style="margin-top: 0">{{$t('Index.Monitoringobject')}}</p>
          <ul>

            <li class="Blue">
              <span @click="$router.push({path:'/monitor/MonitorView',query:{monstatus:'normal'}})">{{objectInfo.normalcount}}</span>
              <p>{{$t('Index.ChannelOK')}}</p>
            </li>
            <li class="Danger">
              <span @click="$router.push({path:'/monitor/MonitorView',query:{monstatus:'all'}})">{{objectInfo.overcount}}</span>
              <p>{{$t('Index.Channeloutoflimit')}}</p>
            </li>
            <li class="Info">
              <span @click="$router.push({path:'/monitor/MonitorView',query:{monstatus:'all'}})">{{objectInfo.offlinecount}}</span>
              <p>{{$t('Index.Channeloffline')}}</p>
            </li>
            <li class="Warning">
              <span @click="$router.push({path:'/monitor/MonitorView',query:{monstatus:'all'}})">{{objectInfo.closecount}}</span>
              <p>{{$t('Index.Channelstop')}}</p>
            </li>
            <li>
              <span @click="$router.push({path:'/monitor/MonitorView',query:{monstatus:'all'}})">{{objectInfo.monitorcount}}</span>
              <p>{{$t('Index.Numberofmonitoringobjects')}}</p>
            </li>
          </ul>
        </div>
      </el-col>
      <el-col :span="24">
        <p class="common-title-font" style="margin-top: 10px"> {{$t('Index.GPSpositioning')}}
          <router-link target="_blank" :to="{path:'/devmap',query:{isAllpage:'1'}}" class="float-right"
                       v-show="showmon!=24">
            <i class="iconfont icon-quanping" style="color: #247af0"></i>
          </router-link>
          <router-link target="_blank" :to="{path:'/monmap',query:{isAllpage:'1'}}" class="float-right"
                       v-show="showmon==24">
            <i class="iconfont icon-quanping" style="color: #247af0"></i>
          </router-link>
        </p>
        <baidu-map class="map" :style="'height:'+(clientHeight-275)+'px'" :center="center" :zoom="zoom"
                   @ready="handler">
        </baidu-map>
      </el-col>
    </div>
    <!--<div class="page_right bg">-->
      <!--<div class="content_item">-->
        <!--<p class="common-title-font" style="margin-top: 0">{{$t('Index.Latestannouncement')}}-->
          <!--<span>-->
            <!--<router-link to="msg/Notice">-->
                  <!--&lt;!&ndash;<el-badge :value="listNotice.total" :max="99" class="item">&ndash;&gt;-->
                      <!--<i class="iconfont icon-gonggao2" style="color:#f56c6c">&nbsp; </i>-->
              <!--&lt;!&ndash;</el-badge>&ndash;&gt;-->
            <!--</router-link>-->
         <!--</span>-->
        <!--</p>-->
        <!--<div class="common-box " v-if="listNotice.total!=0">-->
          <!--<div class="common-box-content scrollbar-right">-->
            <!--<div>-->
              <!--<p v-html="listNotice.contents"></p>-->
            <!--</div>-->
          <!--</div>-->
          <!--<p class="common-title-footer">{{listNotice.displaytime}}</p>-->
        <!--</div>-->
        <!--<div class="common-box " style="height: 200px" v-else>-->
          <!--<img src="http://static.hzjly.cn/img/NoData2.png" style="width: 70px;margin: 0 auto;margin-top: 60px;">-->
          <!--<p style="text-align: center;color:#a2a2a2">{{$t('Index.Noannouncementyet')}}</p>-->
        <!--</div>-->
      <!--</div>-->

      <!--<div class="content_item">-->
        <!--<p class="common-title-font">{{$t('Index.Yunxin')}}-->
          <!--<a href="http://cloudsms.hzjly.cn/overview/Index.html">-->
          <!--<span style="margin-right:0px">-->
                      <!--<i class="iconfont icon-forward"></i>-->
                <!--</span>-->
          <!--</a>-->
        <!--</p>-->


        <!--<div class="common-box " style="padding-bottom: 0" v-if="allcount2!=0||allcount!=0">-->
          <!--<div class="common-box-content " style="overflow: auto;display: flex;height: 175px;margin: 20px 0;">-->
            <!--<div id="cloudsms-left"-->
                 <!--style="flex-grow:1; flex-basis:148px;border-right:1px solid #dcdcdc;padding: 0 15px">-->

            <!--</div>-->
            <!--<div id="cloudsms-right" style="flex-grow:1; flex-basis:148px;padding: 0 15px">-->

            <!--</div>-->
          <!--</div>-->
        <!--</div>-->

        <!--<div class="common-box " style="height: 200px" v-else="allcount2==0&&allcount==0">-->
          <!--<img src="http://static.hzjly.cn/img/NoData2.png" style="width: 70px;margin: 0 auto;margin-top: 60px;">-->
          <!--<a href="http://cloudsms.hzjly.cn/overview/Index.html"><p-->
            <!--style="text-decoration:underline;width: 65%;color: black;margin: 0 auto">{{$t('Index.GoMsg')}}></p>-->
          <!--</a>-->
        <!--</div>-->
      <!--</div>-->

      <!--<div class="content_item">-->
        <!--<p class="common-title-font">{{$t('Index.Messagealert')}}-->
          <!--<span>-->
                <!--<router-link to="msg/Msg">-->
                   <!--&lt;!&ndash;<el-badge :value="ListTopMsg.total" :max="99" class="item">&ndash;&gt;-->
                          <!--<i class="iconfont icon-xiaoxi" style="color:#f56c6c">&nbsp; </i>-->
                  <!--&lt;!&ndash;</el-badge>&ndash;&gt;-->
                <!--</router-link>-->
                <!--</span>-->
        <!--</p>-->
        <!--<div class="common-box " v-show="ListTopMsg.row.length!=0">-->
          <!--<div class="common-box-content scrollbar-right last-bottom" :style="'height:'+(clientHeight-650)+'px'">-->
            <!--<div class="msg_ul">-->
              <!--<div class="msg_li" v-for="item in ListTopMsg.row">-->
                <!--<p>{{item.title}}</p>-->
                <!--<p>{{item.displaytime}}</p>-->
              <!--</div>-->
            <!--</div>-->

          <!--</div>-->
        <!--</div>-->


        <!--<div class="common-box " style="height: 280px" v-show="ListTopMsg.row.length==0">-->
          <!--<img src="http://static.hzjly.cn/img/NoData2.png" style="width: 70px;margin: 0 auto;margin-top: 60px;">-->
          <!--<p style="text-align: center;color:#a2a2a2">{{$t('Index.Nonewsyet')}}</p>-->
        <!--</div>-->

      <!--</div>-->

    <!--</div>-->
    <!--<div class="iframdiv">-->
    <!--<iframe src="http://cloud.hzjly.cn/#/Index" class="ifram" scrolling="no"   frameborder="0" ></iframe>-->
    <!--</div>-->

  </div>

</template>
<script>
  import {BaiduMap} from '../common/Bmap.js';
  import 'echarts/map/js/china.js';
  import 'echarts/extension/bmap/bmap.js';

  export default {
    name: 'index',
    data() {
      return {
        close: true,
        center: {lng: 0, lat: 0},
        zoom: 0,
        _map: {},

        clientHeight: 800,
        showdev: 12,
        showmon: 12,
        point: [104.114129, 37.550339],
        allcount: 1,
        allcount2: 1,
        devInfo: {
          totalcount: '0',
          normalcount: '0',
          overcount: '0',
          offlinecount: '0',
          stopcount: '0',

        },
        objectInfo: {
          monitorcount: '0',
          normalcount: '0',
          overcount: '0',
          offlinecount: '0',
          closecount: '0',
        },
        listNotice: {
          contents: this.$t('JS.msg'),
          createtime: '',
          total: '',
        },
        ListTopMsg: {
          row: [],
          total: '',
        },
      }
    },
    created() {
      this.getDevNumber();
      this.getMonitorNumber();

      if (this.$common.checkPower('4f194a3e-faf5-4c72-b5f7-249b7bd5462f') && this.$common.checkPower('679e18ca-66ab-45bc-83e3-8543eb4d7901')) {
        this.showdev = 12;
        this.showmon = 12;
      } else if (this.$common.checkPower('4f194a3e-faf5-4c72-b5f7-249b7bd5462f') && this.$common.checkPower('679e18ca-66ab-45bc-83e3-8543eb4d7901') == false) {
        this.showdev = 24;
        this.showmon = 0;
      } else if (this.$common.checkPower('4f194a3e-faf5-4c72-b5f7-249b7bd5462f') == false && this.$common.checkPower('679e18ca-66ab-45bc-83e3-8543eb4d7901')) {
        this.showdev = 0;
        this.showmon = 24;
      } else {
        this.showdev = 0;
        this.showmon = 0;

      }
    },
    mounted() {


      let _this = this;
      this.icon();
      // console.log(document.body.clientWidth);
      // console.log(document.body.scrollHeight);
      // console.log();

      this.clientHeight = `${document.getElementsByClassName("el-container")[1].clientHeight}`          //document.body.clientWidth;
      if (this.$common.checkPower('4f194a3e-faf5-4c72-b5f7-249b7bd5462f') == false && this.$common.checkPower('679e18ca-66ab-45bc-83e3-8543eb4d7901')) {
        this.$nextTick(function () {
          BaiduMap.init().then(BMap => {
            this.drawLineMon(BMap);
            this.time = setInterval(() => {
              _this._map.clearOverlays();
              this.drawLineMon();
              this.getDevNumber();
              this.getMonitorNumber();
            }, 1000 * 60)
          })
        })
      } else {
        this.$nextTick(function () {
          BaiduMap.init().then(BMap => {
            this.drawLine(BMap);
            this.time = setInterval(() => {
              _this._map.clearOverlays();
              this.drawLine();
              this.getDevNumber();
              this.getMonitorNumber();
            }, 1000 * 60)
          })
        })
      }


    },

    beforeDestroy() {
      clearInterval(this.time);
      // this.myChart.clear()
    },
    methods: {
      getDevNumber() {
        console.log(this.configUrl + "/Dev/DevStatusCount");
        //获取设备数量
        this.$axios.get(this.configUrl+"/Dev/DevStatusCount", {
          params: {}
        })
          .then(res => {
            var data = res.data;
            data = JSON.parse(data);
            data = data.results.rows;
            this.devInfo = data[0];
          })
          .catch(err => {

          });
      },
      getMonitorNumber() {
        //获取监控对象数量
        this.$axios.get(this.configUrl+"/MonitorObject/MonitorObjectStatusCountTow", {
          params: {}
        })
          .then(res => {
            var data = res.data;
            data = JSON.parse(data);
            data = data.results.result;
            this.objectInfo = data;
          })
          .catch(err => {

          });
      },
      drawLine(Bmap) {
        let _this = this;
        //获取GPS定位
        this.$axios.get(this.configUrl+"/Dev/DevStatusLocationData", {
          params: {}
        })
          .then(res => {
            var data = res.data;
            data = JSON.parse(data);
            data = data.results;
            var maxlat = -1000;
            var minlat = 1000;
            var maxlon = -1000;
            var minlon = 1000;
            data = data.result;


            for (var i = 0; i < data.length; i++) {

              // data[i].gpslat=55.7024010;
              // data[i].gpslon=138.7355756;


              if (data[i].bdlon !== 0 || data[i].bdlat !== 0) {
                data[i].gpslon = data[i].bdlon;
                data[i].gpslat = data[i].bdlat;
              } else if (data[i].protocoltype !== "YZ") {
                if (_this.$common.out_of_china(data[i].gpslon, data[i].gpslat)) {

                } else {
                  var coordinate = _this.$common.wgs84togcj02(data[i].gpslon, data[i].gpslat);
                  coordinate = _this.$common.gcj02tobd09(coordinate[0], coordinate[1]);
                  data[i].gpslon = coordinate[0];
                  data[i].gpslat = coordinate[1];
                }

              } else if (data[i].protocoltype === "YZ") {

                if (_this.$common.out_of_china(data[i].gpslon, data[i].gpslat)) {

                } else {
                  var coordinate = _this.$common.wgs84togcj02(data[i].gpslon, data[i].gpslat);
                  coordinate = _this.$common.gcj02tobd09(coordinate[0], coordinate[1]);
                  data[i].gpslon = coordinate[0];
                  data[i].gpslat = coordinate[1];
                }


              }

              if (_this.$common.out_of_china(data[i].gpslon, data[i].gpslat)) {  //如果在国外
                if (_this.$common.checkPower('7c337538-3c2e-4730-beef-9213f2f3c6d8') == false) {  //且没有展示外国地图权限  则跳过当前循环

                  this.showmap = true;
                  console.log('不展示国外点位');
                  continue;
                } else {
                  console.log('展示国外点位');
                }
              }


              var point;
              let str = '';
              let icon = '';
              if (data[i].gpslat != 0 && data[i].gpslat > maxlat) {
                maxlat = data[i].gpslat;
              }
              if (data[i].gpslat != 0 && data[i].gpslat < minlat) {
                minlat = data[i].gpslat;
              }
              if (data[i].gpslon != 0 && data[i].gpslon > maxlon) {
                maxlon = data[i].gpslon;
              }
              if (data[i].gpslon != 0 && data[i].gpslon < minlon) {
                minlon = data[i].gpslon;
              }
              console.log(data[i].typename);
              switch (data[i].typename) {
                case '冰箱':
                  str = 'Ice_';
                  icon = str + _this.getIcon(_this.CheckStatus(data[i], data[i])[1])
                  break;
                case '环境监测':
                  str = 'Mon_';
                  icon = str + _this.getIcon(_this.CheckStatus(data[i], data[i])[1])
                  break;
                case '保温箱':
                  str = 'Box_';
                  icon = str + _this.getIcon(_this.CheckStatus(data[i], data[i])[1])
                  break;
                case '冷藏车':
                  str = 'Car_';
                  icon = str + _this.getIcon(_this.CheckStatus(data[i], data[i])[1])
                  break;
                case '冷库':
                  str = 'House_';
                  icon = str + _this.getIcon(_this.CheckStatus(data[i], data[i])[1])
                  break;
                case '常温库':
                  str = 'House_';
                  icon = str + _this.getIcon(_this.CheckStatus(data[i], data[i])[1])
                  break;
                default:
                  icon = '';
              }

              data[i].icon = icon;


              if (data[i].gpslat !== 0 && data[i].gpslon !== 0) {


                point = new BMap.Point(data[i].gpslon, data[i].gpslat)
                var that = {
                  name: data[i].name,
                  sn: data[i].sn,
                  isover: data[i].isover,
                  isopen: data[i].isopen,
                  isonline: data[i].isonline,
                  guid: data[i].guid,
                  icon: data[i].icon,
                  value: [data[i].gpslon, data[i].gpslat],
                  channelover: data[i].channelover,
                  channelname: data[i].channelname,
                  channelunit: data[i].channelunit,
                  channelvalue: data[i].channelvalue,
                  channelwarn: data[i].channelwarn,
                  devtime: data[i].devtime,
                }
                this.theLocation(data[i].gpslon, data[i].gpslat, icon, that)
              } else {

                point = new BMap.Point(data[i].bdlon, data[i].bdlat)
                var that = {
                  name: data[i].name,
                  sn: data[i].sn,
                  isover: data[i].isover,
                  isopen: data[i].isopen,
                  isonline: data[i].isonline,
                  guid: data[i].guid,
                  icon: data[i].icon,
                  value: [data[i].bdlon, data[i].bdlat],
                  channelover: data[i].channelover,
                  channelname: data[i].channelname,
                  channelunit: data[i].channelunit,
                  channelvalue: data[i].channelvalue,
                  channelwarn: data[i].channelwarn,
                  devtime: data[i].devtime,
                }

                this.theLocation(data[i].bdlon, data[i].bdlat, icon, that)
              }

        //位移中心至最后一个点
                setTimeout(function () {
                  _this._map.panTo(point);
                }, 200)

            }

            let cha = maxlat - minlat;

            if (this.close) {
              setTimeout(function () {
                if (cha >= 10) {
                  _this._map.setZoom(5);
                }
                if (cha >= 1 && cha < 10) {
                  _this._map.setZoom(7);
                }
                if (cha > 0.5 && cha < 1) {
                  _this._map.setZoom(9);
                }

              }, 1000);
              this.close = false;
            }


          })
          .catch(err => {

          });

      },
      drawLineMon(Bmap) { //监控对象
        let _this = this;
        //获取GPS定位
        this.$axios.get(this.configUrl+"/MonitorObject/MonitorObjectStatusLocationData", {
          params: {}
        })
          .then(res => {
            var data = res.data;
            data = JSON.parse(data);
            data = data.results;
            data = data.result;
            var maxlat = -1000;
            var minlat = 1000;
            var maxlon = -1000;
            var minlon = 1000;

            for (var i = 0; i < data.length; i++) {
              var point;
              let str = '';
              let icon = '';
              if (data[i].gpslat != 0 && data[i].gpslat > maxlat) {
                maxlat = data[i].gpslat;
              }
              if (data[i].gpslat != 0 && data[i].gpslat < minlat) {
                minlat = data[i].gpslat;
              }
              if (data[i].gpslon != 0 && data[i].gpslon > maxlon) {
                maxlon = data[i].gpslon;
              }
              if (data[i].gpslon != 0 && data[i].gpslon < minlon) {
                minlon = data[i].gpslon;
              }

              switch (data[i].typename) {
                case '冰箱':
                  str = 'Ice_';
                  icon = str + _this.getIcon(_this.CheckStatus(data[i], data[i])[1])

                  break;
                case '环境监测':

                  str = 'Mon_';
                  icon = str + _this.getIcon(_this.CheckStatus(data[i], data[i])[1])


                  break;
                case '保温箱':

                  str = 'Box_';
                  icon = str + _this.getIcon(_this.CheckStatus(data[i], data[i])[1])
                  break;
                case '冷藏车':

                  str = 'Car_';
                  icon = str + _this.getIcon(_this.CheckStatus(data[i], data[i])[1])
                  break;
                case '冷库':

                  str = 'House_';
                  icon = str + _this.getIcon(_this.CheckStatus(data[i], data[i])[1])
                  break;
                case '常温库':
                  str = 'House_';
                  icon = str + _this.getIcon(_this.CheckStatus(data[i], data[i])[1])
                  break;

                default:
                  icon = '';
              }

              data[i].icon = icon;


              if (data[i].gpslat > 0 && data[i].gpslon > 0) {
                point = new BMap.Point(data[i].gpslon, data[i].gpslat)
                var that = {
                  name: data[i].name,
                  sn: data[i].sn,
                  isover: data[i].isover,
                  isopen: data[i].isopen,
                  isonline: data[i].isonline,
                  guid: data[i].guid,
                  icon: data[i].icon,
                  value: [data[i].gpslon, data[i].gpslat],
                  channelover: data[i].channelover,
                  channelname: data[i].channelname,
                  channelunit: data[i].channelunit,
                  channelvalue: data[i].channelvalue,
                  channelwarn: data[i].channelwarn,
                  devtime: data[i].devtime,
                }

                this.theLocation(data[i].gpslon, data[i].gpslat, icon, that)
              } else {
                point = new BMap.Point(data[i].bdlon, data[i].bdlat)
                var that = {
                  name: data[i].name,
                  sn: data[i].sn,
                  isover: data[i].isover,
                  isopen: data[i].isopen,
                  isonline: data[i].isonline,
                  guid: data[i].guid,
                  icon: data[i].icon,
                  value: [data[i].bdlon, data[i].bdlat],
                  channelover: data[i].channelover,

                  channelunit: data[i].channelunit,
                  channelname: data[i].channelname,
                  channelvalue: data[i].channelvalue,
                  channelwarn: data[i].channelwarn,
                  devtime: data[i].devtime,
                }

                this.theLocation(data[i].bdlon, data[i].bdlat, icon, that)
              }

                setTimeout(function () {
                  _this._map.panTo(point);
                }, 200)
            }


            let cha = maxlat - minlat;

            if (this.close) {
              setTimeout(function () {
                if (cha >= 10) {
                  _this._map.setZoom(2);
                }
                if (cha >= 1 && cha < 10) {
                  _this._map.setZoom(7);
                }
                if (cha > 0.5 && cha < 1) {
                  _this._map.setZoom(9);
                }

              }, 1000);
              this.close = false;
            }


          })
          .catch(err => {

          });

      },

      checkLonLatChangeNameSN(ary, that) {

        let ary2 = [];
        if (ary.length == 0) {
          ary2.push(that);
        } else {
          ary2 = ary;

          ary.some(function (item, index, array) {

            if (item.value.equals(that.value)) {
              if (item.name != that.name) {
                item.name = item.name + "|" + that.name;
                item.sn = item.sn + "|" + that.sn;
                item.channelover = item.channelover + "|" + that.channelover;
                item.channelunit = item.channelunit + "|" + that.channelunit;
                item.channelvalue = item.channelvalue + "|" + that.channelvalue;
                item.channelwarn = item.channelwarn + "|" + that.channelwarn;
                item.devtime = item.devtime + "|" + that.devtime;
              }
              return true;
            } else if ((index + 1) == ary.length) {
              ary2.push(that);
            }

          })


        }


        return ary2;
      },
      mapInfo(data) { //点击树节点 地图所执行操作
        let _this = this;


        var new_point = new BMap.Point(data.value[0], data.value[1]);
        // _this.deletePoint(data.value[0], data.value[1]);
        // var marker = new BMap.Marker(new_point, {icon: _this[data.icon + '_hover']});  // 创建标注

        // _this._map.addOverlay(marker);              // 将标注添加到地图中
        _this._map.panTo(new_point);


      },
      deletePoint(longitude, latitude) {        //根据经纬度移除标注
        let _this = this;
        var allOverlay = this._map.getOverlays();
        for (var i = 0; i < allOverlay.length; i++) {
          if (allOverlay[i].point == null) {
            continue;
          } else {
            if (allOverlay[i].z.uj == undefined) {
              continue;
            }
            let imgurl = allOverlay[i].z.uj.imageUrl || '';
            //删除其他被标注的点位
            if (imgurl != undefined && imgurl.indexOf('hover') > -1) { //清空原先hover图片标注
              this._map.removeOverlay(allOverlay[i]);
            }

          }
        }
      },
      handler({BMap, map}) {
        let _this = this;
        this._map = map;
        map.centerAndZoom("杭州", 11);  // 初始化地图,设置中心点坐标和地图级别
        //添加地图类型控件
        // map.addControl(new BMap.MapTypeControl({
        //   mapTypes: [
        //     BMAP_NORMAL_MAP,
        //     BMAP_HYBRID_MAP
        //   ]
        // }));
        // map.setCurrentCity("杭州");          // 设置地图显示的城市 此项是必须设置的
        map.enableScrollWheelZoom(true);     //开启鼠标滚轮缩放
        map.clearOverlays();
      },
      theLocation(longitude, latitude, icon, data) { // 根据经纬度创建标注
        let _this = this;
        if (longitude != "" && latitude != "") {
          var new_point = new BMap.Point(longitude, latitude);
          var marker = new BMap.Marker(new_point, {icon: _this[icon]});  // 创建标注

          _this._map.addOverlay(marker);              // 将标注添加到地图中

          marker.customData = {data: data}

          // marker.addEventListener("click", _this.getMark);


          var opts = {
            width: 280,     // 信息窗口宽度
            offset: {
              width: 0,
              height: -25,
            },
            title: "", // 信息窗口标题
            enableMessage: false,//设置允许信息窗发送短息
            message: ""
          }

          let showhtml = `<p style="margin-bottom: 10px">名称 : ${data.name} `;
          if (data.sn) {
            showhtml += `( ${data.sn} )</p>`
          } else {
            showhtml += `</p>`
          }

          let value = data.channelvalue.split(',');
          let unit = data.channelunit.split(',');
          let over = data.channelover.split(',');
          let name = data.channelname.split(',');

          for (let j = 0; j < data.channelvalue.split(',').length; j++) {
            let className = '';
            if (Number(value[j]) > 1000 || value[j] < -1000) {
              value[j] = null;
            }
            if (over[j] == 1) {
              className = 'redFont'
            }

            showhtml += '<span style="display: inline-block;width: 130px" class="' + className + '">' + name[j] + ': ' + value[j] + '' + unit[j] + '</span> &nbsp;'

          }
          if (data.devtime) {
            showhtml += `<p  style="margin-top: 10px">${data.devtime}</p>`
          }


          var infoWindow = new BMap.InfoWindow(showhtml, opts);  // 创建信息窗口对象
          marker.addEventListener("click", function () {
            _this.mapInfo(data);
            _this._map.openInfoWindow(infoWindow, new_point); //开启信息窗口
          });

        }
      },
      getMark(e) {
        console.log(e.target.customData.data);
      },
      getIcon(text) {
        switch (text) {
          case 'bt':
            return 'stop';
            break;
          case 'lx':
            return 'offline';
            break;
          case 'cb':
            return 'danger';
            break;
          case 'yj':
            return 'stop';
            break;
          case 'zc':
            return 'normal';
            break;
        }
      },
      CheckStatus(item, item2) {
        if (item.isopen == false) {   //报停
          return [item2.typename, 'bt'];
        } else if (item.isonline == false) { //离线
          return [item2.typename, 'lx'];
        } else if (item.isover == true) { //超标
          return [item2.typename, 'cb'];
        } else if (item.iswarn == true) { //预警
          return [item2.typename, 'yj'];
        } else { //正常
          return [item2.typename, 'zc'];
        }

      },
      GeocoderAdr(Adr, icon, data) {   //根据地址创建标注
        let _this = this;
        // 创建地址解析器实例
        var myGeo = new BMap.Geocoder();
        // 将地址解析结果显示在地图上,并调整地图视野

        myGeo.getPoint(Adr, function (point) {
          if (point) {
            var marker = new BMap.Marker(point, {icon: _this[icon]});  // 创建标注
            _this._map.addOverlay(marker);
            marker.customData = {data: data}
            marker.addEventListener("click", _this.getMark);
          }
        }, "");
      },
      icon() {  //图标注册
        let _this = this;
        //冷库
        //报停
        _this.House_stop_hover = new BMap.Icon('http://static.hzjly.cn/MonitorSystem/img/location_icon_warehouse_stop_hover.png', new BMap.Size(25, 38), {//是引用图标的名字以及大小，注意大小要一样
          anchor: new BMap.Size(10, 30)//这句表示图片相对于所加的点的位置
        });
        _this.House_stop = new BMap.Icon('http://static.hzjly.cn/MonitorSystem/img/location_icon_warehouse_stop.png', new BMap.Size(25, 38), {//是引用图标的名字以及大小，注意大小要一样
          anchor: new BMap.Size(10, 30)//这句表示图片相对于所加的点的位置
        });
        //离线
        _this.House_offline_hover = new BMap.Icon('http://static.hzjly.cn/MonitorSystem/img/location_icon_warehouse_offline_hover.png', new BMap.Size(25, 38), {//是引用图标的名字以及大小，注意大小要一样
          anchor: new BMap.Size(10, 30)//这句表示图片相对于所加的点的位置
        });
        _this.House_offline = new BMap.Icon('http://static.hzjly.cn/MonitorSystem/img/location_icon_warehouse_offline.png', new BMap.Size(25, 38), {//是引用图标的名字以及大小，注意大小要一样
          anchor: new BMap.Size(10, 30)//这句表示图片相对于所加的点的位置
        });
        //正常
        _this.House_normal_hover = new BMap.Icon('http://static.hzjly.cn/MonitorSystem/img/location_icon_warehouse_normal_hover.png', new BMap.Size(25, 38), {//是引用图标的名字以及大小，注意大小要一样
          anchor: new BMap.Size(10, 30)//这句表示图片相对于所加的点的位置
        });
        _this.House_normal = new BMap.Icon('http://static.hzjly.cn/MonitorSystem/img/location_icon_warehouse_normal.png', new BMap.Size(25, 38), {//是引用图标的名字以及大小，注意大小要一样
          anchor: new BMap.Size(10, 30)//这句表示图片相对于所加的点的位置
        });
        //超标
        _this.House_danger_hover = new BMap.Icon('http://static.hzjly.cn/MonitorSystem/img/location_icon_warehouse_danger_hover.png', new BMap.Size(25, 38), {//是引用图标的名字以及大小，注意大小要一样
          anchor: new BMap.Size(10, 30)//这句表示图片相对于所加的点的位置
        });
        _this.House_danger = new BMap.Icon('http://static.hzjly.cn/MonitorSystem/img/location_icon_warehouse_danger.png', new BMap.Size(25, 38), {//是引用图标的名字以及大小，注意大小要一样
          anchor: new BMap.Size(10, 30)//这句表示图片相对于所加的点的位置
        });
        //冷库


        //冷藏车
        //报停
        _this.Car_stop_hover = new BMap.Icon('http://static.hzjly.cn/MonitorSystem/img/location_icon_car_stop_hover.png', new BMap.Size(25, 38), {//是引用图标的名字以及大小，注意大小要一样
          anchor: new BMap.Size(10, 30)//这句表示图片相对于所加的点的位置
        });
        _this.Car_stop = new BMap.Icon('http://static.hzjly.cn/MonitorSystem/img/location_icon_car_stop.png', new BMap.Size(25, 38), {//是引用图标的名字以及大小，注意大小要一样
          anchor: new BMap.Size(10, 30)//这句表示图片相对于所加的点的位置
        });
        //离线
        _this.Car_offline_hover = new BMap.Icon('http://static.hzjly.cn/MonitorSystem/img/location_icon_car_offline_hover.png', new BMap.Size(25, 38), {//是引用图标的名字以及大小，注意大小要一样
          anchor: new BMap.Size(10, 30)//这句表示图片相对于所加的点的位置
        });
        _this.Car_offline = new BMap.Icon('http://static.hzjly.cn/MonitorSystem/img/location_icon_car_offline.png', new BMap.Size(25, 38), {//是引用图标的名字以及大小，注意大小要一样
          anchor: new BMap.Size(10, 30)//这句表示图片相对于所加的点的位置
        });
        //正常
        _this.Car_normal_hover = new BMap.Icon('http://static.hzjly.cn/MonitorSystem/img/location_icon_car_normal_hover.png', new BMap.Size(25, 38), {//是引用图标的名字以及大小，注意大小要一样
          anchor: new BMap.Size(10, 30)//这句表示图片相对于所加的点的位置
        });
        _this.Car_normal = new BMap.Icon('http://static.hzjly.cn/MonitorSystem/img/location_icon_car_normal.png', new BMap.Size(25, 38), {//是引用图标的名字以及大小，注意大小要一样
          anchor: new BMap.Size(10, 30)//这句表示图片相对于所加的点的位置
        });
        //超标
        _this.Car_danger_hover = new BMap.Icon('http://static.hzjly.cn/MonitorSystem/img/location_icon_car_danger_hover.png', new BMap.Size(25, 38), {//是引用图标的名字以及大小，注意大小要一样
          anchor: new BMap.Size(10, 30)//这句表示图片相对于所加的点的位置
        });
        _this.Car_danger = new BMap.Icon('http://static.hzjly.cn/MonitorSystem/img/location_icon_car_danger.png', new BMap.Size(25, 38), {//是引用图标的名字以及大小，注意大小要一样
          anchor: new BMap.Size(10, 30)//这句表示图片相对于所加的点的位置
        });
        //冷藏车


        //环境监测
        //报停
        _this.Mon_stop_hover = new BMap.Icon('http://static.hzjly.cn/MonitorSystem/img/location_icon_monitor_stop_hover.png', new BMap.Size(25, 38), {//是引用图标的名字以及大小，注意大小要一样
          anchor: new BMap.Size(10, 30)//这句表示图片相对于所加的点的位置
        });
        _this.Mon_stop = new BMap.Icon('http://static.hzjly.cn/MonitorSystem/img/location_icon_monitor_stop.png', new BMap.Size(25, 38), {//是引用图标的名字以及大小，注意大小要一样
          anchor: new BMap.Size(10, 30)//这句表示图片相对于所加的点的位置
        });
        //离线
        _this.Mon_offline_hover = new BMap.Icon('http://static.hzjly.cn/MonitorSystem/img/location_icon_monitor_offline_hover.png', new BMap.Size(25, 38), {//是引用图标的名字以及大小，注意大小要一样
          anchor: new BMap.Size(10, 30)//这句表示图片相对于所加的点的位置
        });
        _this.Mon_offline = new BMap.Icon('http://static.hzjly.cn/MonitorSystem/img/location_icon_monitor_offline.png', new BMap.Size(25, 38), {//是引用图标的名字以及大小，注意大小要一样
          anchor: new BMap.Size(10, 30)//这句表示图片相对于所加的点的位置
        });
        //正常
        _this.Mon_normal_hover = new BMap.Icon('http://static.hzjly.cn/MonitorSystem/img/location_icon_monitor_normal_hover.png', new BMap.Size(25, 38), {//是引用图标的名字以及大小，注意大小要一样
          anchor: new BMap.Size(10, 30)//这句表示图片相对于所加的点的位置
        });
        _this.Mon_normal = new BMap.Icon('http://static.hzjly.cn/MonitorSystem/img/location_icon_monitor_normal.png', new BMap.Size(25, 38), {//是引用图标的名字以及大小，注意大小要一样
          anchor: new BMap.Size(10, 30)//这句表示图片相对于所加的点的位置
        });
        //超标
        _this.Mon_danger_hover = new BMap.Icon('http://static.hzjly.cn/MonitorSystem/img/location_icon_monitor_danger_hover.png', new BMap.Size(25, 38), {//是引用图标的名字以及大小，注意大小要一样
          anchor: new BMap.Size(10, 30)//这句表示图片相对于所加的点的位置
        });
        _this.Mon_danger = new BMap.Icon('http://static.hzjly.cn/MonitorSystem/img/location_icon_monitor_danger.png', new BMap.Size(25, 38), {//是引用图标的名字以及大小，注意大小要一样
          anchor: new BMap.Size(10, 30)//这句表示图片相对于所加的点的位置
        });
        //环境监测


        //冰箱
        //报停
        _this.Ice_stop_hover = new BMap.Icon('http://static.hzjly.cn/MonitorSystem/img/location_icon_icebox_stop_hover.png', new BMap.Size(25, 38), {//是引用图标的名字以及大小，注意大小要一样
          anchor: new BMap.Size(10, 30)//这句表示图片相对于所加的点的位置
        });
        _this.Ice_stop = new BMap.Icon('http://static.hzjly.cn/MonitorSystem/img/location_icon_icebox_stop.png', new BMap.Size(25, 38), {//是引用图标的名字以及大小，注意大小要一样
          anchor: new BMap.Size(10, 30)//这句表示图片相对于所加的点的位置
        });
        //离线
        _this.Ice_offline_hover = new BMap.Icon('http://static.hzjly.cn/MonitorSystem/img/location_icon_icebox_offline_hover.png', new BMap.Size(25, 38), {//是引用图标的名字以及大小，注意大小要一样
          anchor: new BMap.Size(10, 30)//这句表示图片相对于所加的点的位置
        });
        _this.Ice_offline = new BMap.Icon('http://static.hzjly.cn/MonitorSystem/img/location_icon_icebox_offline.png', new BMap.Size(25, 38), {//是引用图标的名字以及大小，注意大小要一样
          anchor: new BMap.Size(10, 30)//这句表示图片相对于所加的点的位置
        });
        //正常
        _this.Ice_normal_hover = new BMap.Icon('http://static.hzjly.cn/MonitorSystem/img/location_icon_icebox_normal_hover.png', new BMap.Size(25, 38), {//是引用图标的名字以及大小，注意大小要一样
          anchor: new BMap.Size(10, 30)//这句表示图片相对于所加的点的位置
        });
        _this.Ice_normal = new BMap.Icon('http://static.hzjly.cn/MonitorSystem/img/location_icon_icebox_normal.png', new BMap.Size(25, 38), {//是引用图标的名字以及大小，注意大小要一样
          anchor: new BMap.Size(10, 30)//这句表示图片相对于所加的点的位置
        });
        //超标
        _this.Ice_danger_hover = new BMap.Icon('http://static.hzjly.cn/MonitorSystem/img/location_icon_icebox_danger_hover.png', new BMap.Size(25, 38), {//是引用图标的名字以及大小，注意大小要一样
          anchor: new BMap.Size(10, 30)//这句表示图片相对于所加的点的位置
        });
        _this.Ice_danger = new BMap.Icon('http://static.hzjly.cn/MonitorSystem/img/location_icon_icebox_danger.png', new BMap.Size(25, 38), {//是引用图标的名字以及大小，注意大小要一样
          anchor: new BMap.Size(10, 30)//这句表示图片相对于所加的点的位置
        });
        //冰箱


        //保温箱
        //报停
        _this.Box_stop_hover = new BMap.Icon('http://static.hzjly.cn/MonitorSystem/img/location_icon_box_stop_hover.png', new BMap.Size(25, 38), {//是引用图标的名字以及大小，注意大小要一样
          anchor: new BMap.Size(10, 30)//这句表示图片相对于所加的点的位置
        });
        _this.Box_stop = new BMap.Icon('http://static.hzjly.cn/MonitorSystem/img/location_icon_box_stop.png', new BMap.Size(25, 38), {//是引用图标的名字以及大小，注意大小要一样
          anchor: new BMap.Size(10, 30)//这句表示图片相对于所加的点的位置
        });
        //离线
        _this.Box_offline_hover = new BMap.Icon('http://static.hzjly.cn/MonitorSystem/img/location_icon_box_offline_hover.png', new BMap.Size(25, 38), {//是引用图标的名字以及大小，注意大小要一样
          anchor: new BMap.Size(10, 30)//这句表示图片相对于所加的点的位置
        });
        _this.Box_offline = new BMap.Icon('http://static.hzjly.cn/MonitorSystem/img/location_icon_box_offline.png', new BMap.Size(25, 38), {//是引用图标的名字以及大小，注意大小要一样
          anchor: new BMap.Size(10, 30)//这句表示图片相对于所加的点的位置
        });
        //正常
        _this.Box_normal_hover = new BMap.Icon('http://static.hzjly.cn/MonitorSystem/img/location_icon_box_normal_hover.png', new BMap.Size(25, 38), {//是引用图标的名字以及大小，注意大小要一样
          anchor: new BMap.Size(10, 30)//这句表示图片相对于所加的点的位置
        });
        _this.Box_normal = new BMap.Icon('http://static.hzjly.cn/MonitorSystem/img/location_icon_box_normal.png', new BMap.Size(25, 38), {//是引用图标的名字以及大小，注意大小要一样
          anchor: new BMap.Size(10, 30)//这句表示图片相对于所加的点的位置
        });
        //超标
        _this.Box_danger_hover = new BMap.Icon('http://static.hzjly.cn/MonitorSystem/img/location_icon_box_danger_hover.png', new BMap.Size(25, 38), {//是引用图标的名字以及大小，注意大小要一样
          anchor: new BMap.Size(10, 30)//这句表示图片相对于所加的点的位置
        });
        _this.Box_danger = new BMap.Icon('http://static.hzjly.cn/MonitorSystem/img/location_icon_box_danger.png', new BMap.Size(25, 38), {//是引用图标的名字以及大小，注意大小要一样
          anchor: new BMap.Size(10, 30)//这句表示图片相对于所加的点的位置
        });
        //保温箱


        _this.myIcon = new BMap.Icon('http://static.hzjly.cn/MonitorSystem/img/location_icon_blue.png', new BMap.Size(25, 38), {//是引用图标的名字以及大小，注意大小要一样
          anchor: new BMap.Size(10, 30)//这句表示图片相对于所加的点的位置
        });
        _this.myIcon2 = new BMap.Icon('http://static.hzjly.cn/MonitorSystem/img/location_icon_red.png', new BMap.Size(25, 38), {//是引用图标的名字以及大小，注意大小要一样
          anchor: new BMap.Size(10, 30)//这句表示图片相对于所加的点的位置
        });

      },

    }
  }
</script>

<style scoped>

  .map {
    position: relative;
    width: 100%;
    min-height: 550px;
  }

  .ifram {
    position: fixed;
    right: 0;
    border: 1px silver solid;
    bottom: 200px;
    width: 200px;
    height: 100px;
  }

  .ifram:hover {
    width: 400px;
  }

  a {
    text-decoration: none;
    out-line: none;
    color: inherit;
  }

  .msg_ul {
    padding: 0 15px !important;
  }

  .msg_li {
    padding: 10px 5px !important;
    color: #a2a2a2;
    border-bottom: 1px #e6e6e6 solid;
  }

  .msg_li p {
    padding-top: 10px;
  }

  .last-bottom {
    min-height: 180px;
  }

  .common-box {
    padding-bottom: 15px;
    display: flex;
    flex-direction: column;

  }

  .common-box-content {
    overflow: hidden;
    overflow-x: hidden;
    width: 100%;
    height: 150px;
  }

  .common-box-content div {
    padding: 15px;

  }

  .common-title-footer {
    padding: 10px 10px 0 0;
    border-top: 1px #e6e6e6 solid;
    text-align: right;
    color: #a2a2a2;
  }

  .page_left {
    flex-grow: 8;
    flex-basis: 700px;
    padding-right: 15px;
  }

  .page_right {
    flex-grow: 2;
    flex-basis: 150px;
    position: relative
  }


  .common-title-font {
    width: auto;
    height: 16px;
    margin-top: 16px;
    line-height: 16px;
    background-color: #fbfbfc;
    padding: 16px;
    padding-left: 0;
    /*border-left: 2px solid #247af0;*/
    border-bottom: 1px #dfdfdf solid;
  }

  .common-title-font span {
    float: right;
    margin-right: 10px
  }

  .common-title-font:before {
    content: '';
    margin: 0 8px;
    margin-left: 18px;
    border-left: 2px solid #247af0;

  }

  .content_item {
    min-width: 160px;
    background-color: white;
  }

  .content_item ul {
    width: 100%;
    display: flex;
  }

  .content_item ul li {
    text-align: center;
    flex-grow: 1;
    margin: 25px 0;
    padding-top: 7px;
    padding-bottom: 7px;
    border-left: 1px dashed #eaedf1;

  }

  .content_item ul li span {
    font-size: 30px;
  }

  .content_item span {
    cursor: pointer;
  }

  >>> .anchorBL {

    display: none;

  }

  /*地图标题*/


  /* 隐藏边角 */
  >>> .BMap_pop div:nth-child(1) div {
    border-radius: 5px;
  }

  >>> .BMap_pop div:nth-child(5) div {
    border-radius: 5px;
  }

  >>> .BMap_pop div:nth-child(3) div {
    border-radius: 5px;
  }

  >>> .BMap_pop div:nth-child(7) div {
    border-radius: 5px;

  }

  >>> .redFont {
    color: #fe0201;
  }
</style>



// WEBPACK FOOTER //
// src/components/Index.vue